import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { CelebrationAnimationService } from "@core/celebration-animation.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { BehaviorSubject, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { GamesRepositoryService } from "./../../../games/games-repository.service";
import { NgClass, NgStyle, AsyncPipe } from "@angular/common";
import { GameCelebrationService } from "src/app/pages/games/services/game-celebration.service";
const thousandMilliseconds = 1000;
const twentyFiveHundredMilliseconds = 3000;
const threeThousandMilliseconds = 4000;
@Component({
    selector: "app-hero-rank-animation",
    templateUrl: "./hero-rank-animation.component.html",
    styleUrls: ["./hero-rank-animation.component.css"],
    standalone: true,
    imports: [
        LottieComponent,
        NgClass,
        NgStyle,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class HeroRankAnimationComponent implements OnInit {
  textDisable = true;
  communityRocketVisible: boolean;
  fortuneRocketVisible: boolean;
  gamingRocketVisible: boolean;
  vipRocketVisible: boolean;
  levelUpContent: boolean;
  batchVisible: boolean;
  greetingsContent: boolean;
  public rankLevelData$ = new BehaviorSubject({});

  community: AnimationOptions = {
    path: "../../../assets/hero-rank/RocketCommunity.json",
  };
  fortune: AnimationOptions = {
    path: "../../../assets/hero-rank/RocketFortune.json",
  };
  gaming: AnimationOptions = {
    path: "../../../assets/hero-rank/RocketGaming.json",
  };
  vip: AnimationOptions = {
    path: "../../../assets/hero-rank/RocketVIP.json",
  };
  puls: AnimationOptions = {
    path: "../../../assets/hero-rank/Animation - 1689330230985.json",
  };
  title: string;
  docID: string;
  celebrationTitle: string;
  selectedLanguage: string;
  spanish: boolean;
  // This variable is used to contain current Celebration Colors
  public textColors: Data;

  constructor(
    private matDialogRef: MatDialogRef<HeroRankAnimationComponent>,
    private celebrationAnimationService: CelebrationAnimationService,
    private gamesRepositoryService: GamesRepositoryService,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private gameCelebrationService : GameCelebrationService,
    @Inject(MAT_DIALOG_DATA) public data: Data
  ) {
    this.textColors = {
      Community: "#36A5F9",
      Fortune: "#33D26D",
      Gaming: "#FFA602",
      VIP: "#978DF5",
    };
    // This variable is used to contain current Celebration data
    const currentRank = this.data?.data?.celebration_rank?.current_rank;
    this.docID = this.data.id;
    this.celebrationTitle = this.data?.data?.celebration_rank?.title.replace(
      /[""]+/g,
      ""
    );
    this.title = this.celebrationTitle?.toLowerCase();
    // This method has been used to get current Celebration data
    this.celebrationAnimationService
      .globalGamificationRanksData(currentRank, this.title)
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      )
      .subscribe((res: Data) => {
        try {
          this.rankLevelData$.next(res);
        } catch (error) {
          return throwError(error);
        }
      });
    // This method has been used to get selected language
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        this.translate.use(l ? l : "en");
        if (l == "es") {
          this.spanish = true;
        }
      },
      (err) => {
        return err;
      }
    );
  }
  ionViewWillEnter() {
    this.celebrationAnimationService.trackCelebrations();
  }
  ngOnInit(): void {
    this.LoadingDisable();
  }
  LoadingDisable() {
    setTimeout(() => {
      this.textDisable = false;
      // This method  has been  used to trigger the rocket animation
      this.rocketAnimation();
    }, twentyFiveHundredMilliseconds);
  }
  // This method  has been  used to open the rocket animation
  rocketAnimation() {
    switch (this.title) {
      case "community":
        this.communityRocketVisible = true;
        break;
      case "fortune":
        this.fortuneRocketVisible = true;
        break;
      case "gaming":
        this.gamingRocketVisible = true;
        break;
      case "vip":
        this.vipRocketVisible = true;
        break;
      default:
        // In default case it will be empty
        break;
    }
    setTimeout(() => {
      // This method  has been  used to close the rocket animation
      this.batchAnimation();
    }, threeThousandMilliseconds);
  }

  // This method  has been  used to open the batch animation
  batchAnimation() {
    this.rocketAnimationClose();
    // This variable is used to update the animation flow according to the condition
    this.levelUpContent = true;
    this.batchVisible = true;
    // This method  has been  used to trigger the batch animation
    setTimeout(() => {
      this.greetingsContent = true;
    }, thousandMilliseconds);
  }
  // This method  has been  used to close the rocket animation
  rocketAnimationClose() {
    // This switch is used to change the rocket animation color according to celebration status
    switch (this.title) {
      case "community":
        this.communityRocketVisible = false;
        break;
      case "fortune":
        this.fortuneRocketVisible = false;
        break;
      case "gaming":
        this.gamingRocketVisible = false;
        break;
      case "vip":
        this.vipRocketVisible = false;
        break;
      default:
        // In default case it will be empty
        break;
    }
  }

  // This method  has been  used to close the dialog
  closeDialog(ctaType: string) {
    // This switch is used to change the CTA functionality according to the condition
    switch (ctaType) {
      case "OK":
        this.updateCelebration();
        this.matDialogRef.close();
        break;
      case "Claim-gift":
        this.matDialogRef.close();
        this.router.navigateByUrl("mainTabs/tabs/social");
        this.updateCelebration();
        break;
    }
  }
  // This method  has been  used to update celebration
  updateCelebration() {
    // This method  has been  used to update the current rank celebration document
    if (!this.docID) return;
    this.gameCelebrationService.updateRankDetailsData(this.docID);
    // This method  has been  used to update the current celebration document
    this.gameCelebrationService.updateCurrentCelebrationDocument();
  }
}
